import { exhaustMap } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { CrossWordsRound } from '@api/models/cross-words-round.entity';
import {
	CrossWordsRoundQuestionService,
	CrossWordsRoundQuestionUpdatePathVariables,
} from '@api/services/cross-words-round-question.service';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { GamesSelectors } from '../../games.selectors';
import { CrossWordsPhaseSelectors } from '../cross-words-phase.selectors';
import {
	CrossWordsRoundQuestionActions,
	CrossWordsRoundQuestionUpdateAction,
} from './cross-words-round-question.actions';

@Injectable()
export class CrossWordsRoundQuestionEffects {
	public update$ = createEffect(
		() => {
			return this.actions$.pipe(
				ofType(CrossWordsRoundQuestionActions.update),
				concatLatestFrom((action) => [
					this.store.select(GamesSelectors.id),
					this.store.select(
						CrossWordsPhaseSelectors.round(action.roundId),
					),
				]),
				exhaustMap(
					([{ roundId, hitted }, gameId, round]: [
						CrossWordsRoundQuestionUpdateAction,
						string,
						CrossWordsRound,
					]) => {
						const pathVariables: CrossWordsRoundQuestionUpdatePathVariables =
							{
								gameId,
								roundId,
								questionId: round.currentQuestion.toString(),
							};

						const body = { hitted, time: round.time };
						return this.crossWordsRoundQuestionService.update(
							pathVariables,
							body,
						);
					},
				),
			);
		},
		{ dispatch: false },
	);

	constructor(
		private actions$: Actions,
		private store: Store,
		private crossWordsRoundQuestionService: CrossWordsRoundQuestionService,
	) {}
}
